import { Column } from 'react-table';
import { ImportProduct } from '../../../../types/purchases/BasePurchase';

export type ImportCustomColumn = Column<ImportProduct> & {
  customCell?: (cell: any) => JSX.Element | string;
  className?: string;
};

// 📦 Formato de celdas
const currencyCell = (cell: any) => `$${Number(cell.value).toFixed(2)}`;
const percentageCell = (cell: any) => `${Number(cell.value).toFixed(2)}%`;

// 📋 Columnas para productos de importación
export const importProductColumns: ImportCustomColumn[] = [
  {
    Header: '#',
    id: 'rowIndex',
    accessor: 'id',
    customCell: (cell: any) => {
      const index = cell.row.index;
      const { pageIndex = 0, pageSize = 10 } = cell.table?.state || {};
      return pageIndex * pageSize + index + 1;
    },
  },
  {
    Header: 'Producto',
    accessor: 'productName',
    customCell: ({ row }) => {
      const { productCode, productName, categoryName } = row.original;
      return (
        <div className="text-sm leading-6">
          {/* Código del producto */}
          <div className="font-mono text-gray-500 dark:text-gray-400 text-xs">
            {productCode ? `(${productCode})` : '—'}
          </div>
          {/* Nombre */}
          <div className="font-medium text-black dark:text-white">
            {productName}
          </div>
          {/* Categoría (misma caja/clases, ahora en dos líneas) */}
          <div className="text-gray-600 dark:text-gray-400 mt-1 text-xs">
            <div>
              <strong>CATEGORÍA:</strong>
            </div>
            <div>{categoryName || '—'}</div>
          </div>
        </div>
      );
    },
  },
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    customCell: ({ row }) => {
      const { quantity, unitCode, settledQuantity } = row.original;

      return (
        <div className="text-sm leading-6">
          <div>
            {Number(quantity).toFixed(2)} {unitCode || ''}
          </div>

          {settledQuantity !== undefined && (
            <div className="text-gray-500 mt-1 text-xs">
              <strong>Asentado:</strong> {Number(settledQuantity).toFixed(2)}{' '}
              {unitCode || ''}
            </div>
          )}
        </div>
      );
    },
  },
  ,
  { Header: 'Monto', accessor: 'amount', customCell: currencyCell },
  { Header: 'C/Inicial', accessor: 'initialCost', customCell: currencyCell },
  { Header: '%', accessor: 'percentage', customCell: percentageCell },
  { Header: 'Flete', accessor: 'freight', customCell: currencyCell },
  { Header: 'Seguro', accessor: 'insurance', customCell: currencyCell },
  { Header: 'Fauca', accessor: 'fauca', customCell: currencyCell },
  { Header: 'Otros', accessor: 'others', customCell: currencyCell },
  { Header: 'C/Total', accessor: 'totalCost', customCell: currencyCell },
  {
    Header: 'Costo c/Extras',
    accessor: 'unitCostWithExtras',
    customCell: currencyCell,
  },
];
